import "../assets/common8.css";
import { c as l } from "./index.bddf5ebb.js";
const c = "_button_17zei_1", d = "_primary_17zei_34", r = "_secondary_17zei_48", g = "_dark_17zei_62", m = "_outline_17zei_77", z = "_ghost_17zei_92", u = "_leading_17zei_105", p = "_large_17zei_109", y = "_medium_17zei_118", b = "_small_17zei_127", h = "_loading_17zei_141", k = "_loadingIcon_17zei_142", I = "_spin_17zei_1", n = {
  button: c,
  primary: d,
  secondary: r,
  dark: g,
  outline: m,
  ghost: z,
  leading: u,
  large: p,
  medium: y,
  small: b,
  loading: h,
  loadingIcon: k,
  spin: I
}, N = ({
  className: e,
  contrast: _,
  icon: t,
  iconPosition: o,
  isLoading: a,
  size: i,
  variant: s
}) => l(n.button, e, {
  [n.loading]: a,
  [n[_]]: !!_ && _ !== "light",
  [n[o]]: !!t && o !== "trailing",
  [n[i]]: !!i,
  [n[s]]: !!s
});
export {
  N as c,
  n as s
};
//# sourceMappingURL=common.4f8de070.js.map
